interface ProductTypeBadgeProps {
  type: 'Kaftan' | 'Agbada' | 'Dashiki' | 'Boubou' | string
}

export const ProductTypeBadge = ({ type }: ProductTypeBadgeProps) => {
  return (
    <span className="px-3  text-sm font-medium rounded-[10px] bg-[#E2DEF7] text-foreground min-w-[103px] h-[25px] flex items-center justify-center text-center">
      {type}
    </span>
  )
}